import { h } from 'preact'
import DropdownList from './DropdownList'
import Dropdown from './index'
import { GroupedItemsList, ItemsList } from "./interfaces";

interface Props {
    type: string,
    align: string,
    trigger: string,
    items: ItemsList | GroupedItemsList,
    displayListUpwards: boolean,
    hasSearch?: boolean
}

const DropdownControl = ({ type, align, trigger, items, displayListUpwards, hasSearch }: Props) => {

  return (
    <Dropdown
      class={'control-dropdown'}
      trigger={trigger}
    >
      <DropdownList
        displayListUpwards={displayListUpwards}
        type={type}
        align={align}
        items={items}
        hasSearch={hasSearch || false}
      />
    </Dropdown>
  )
}

export default DropdownControl
